import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
  import { useInspectionReport } from '@/ui/components/inspectionReport/useInspectioReport';
  import { formatSameAsI18nWithoutTimeZone, type KnownI18nDateTimeFormat } from '@/ui/i18n/formatSameAsI18nNoTZ';
  import { LegacyItem, LegacyParams } from '@/ui/components/inspectionReport/legacyTypes';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Datetime',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as { item: LegacyItem };

  
  const inspectionReportItem = props.item;

  const notRespondedText = useInspectionReport().getNotRespondedAnswer();

  const getFormat = (questionParameters: LegacyParams): KnownI18nDateTimeFormat|string => {
    switch (true) {
      case !!questionParameters.date && !!questionParameters.time:
        return 'shortDateTime';
      case !!questionParameters.date:
        return 'shortDate';
      case !!questionParameters.time:
        return 'shortTime';
      default:
        return '';
    }
  };

  const normalizeForDateTime = (rawResponse): string => {
    const hasAmOrPm = /am|pm/i.test(rawResponse);
    if (hasAmOrPm) {
      return rawResponse;
    }
    const replacedSpaceWithT = rawResponse.replace(' ', 'T');

    return `${replacedSpaceWithT}:00`;
  };

  const normalizeForDate = (rawResponse): string => {
    return `${rawResponse}T00:00:00`;
  };

  const normalizeForBaseDate = (rawResponse): string => {
    const baseDateOnlyForParsing = '1995-07-04';
    const hasAmOrPm = /am|pm/i.test(rawResponse);

    if (hasAmOrPm) {
      return `${baseDateOnlyForParsing} ${rawResponse}`;
    }

    return `${baseDateOnlyForParsing}T${rawResponse}:00`;
  };

  const getNormalizedDateString = (questionParameters: LegacyParams, rawResponse): string => {
    if (questionParameters.date && questionParameters.time) {
      return normalizeForDateTime(rawResponse);
    }

    if (questionParameters.date) {
      return normalizeForDate(rawResponse);
    }

    return normalizeForBaseDate(rawResponse);
  };

  const formattedValue = computed<string>(() => {
    const rawResponse = inspectionReportItem.response as string | undefined;

    if (!rawResponse) {
      return '';
    }

    const { params } = inspectionReportItem;

    const dateTimeFormatKey: KnownI18nDateTimeFormat = getFormat(params);

    const normalizedDateString: string = getNormalizedDateString(params, rawResponse);

    const parsedDate = new Date(normalizedDateString);

    if (Number.isNaN(+parsedDate)) {
      return '';
    }

    return formatSameAsI18nWithoutTimeZone(parsedDate, dateTimeFormatKey);
  });

return { __sfc: true,props, inspectionReportItem, notRespondedText, getFormat, normalizeForDateTime, normalizeForDate, normalizeForBaseDate, getNormalizedDateString, formattedValue }
}

})